import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import GoldSeam from "@/components/GoldSeam";

export const STEPS = [
  { n: "01", name: "See", line: "Name the pattern out loud — often for the first time." },
  { n: "02", name: "Understand", line: "Trace it to the root: where it started, what it protected." },
  { n: "03", name: "Release", line: "Let the nervous system put down what it no longer needs." },
  { n: "04", name: "Reframe", line: "Turn the crack into the seam — meaning, made visible." },
  { n: "05", name: "Realign", line: "Live from the new pattern, one analog choice at a time." },
];

export default function Method() {
  return (
    <section id="method" className="relative py-24 md:py-36 bg-paper" data-testid="method-section">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <p className="eyebrow mb-6">The Approach</p>
              <h2 className="font-display text-ink font-medium leading-[1.1] text-4xl sm:text-5xl" data-testid="method-heading">
                The T.A.L.K. Method<span className="text-gold align-super text-2xl">™</span>
              </h2>
              <p className="mt-7 text-inkdim leading-relaxed max-w-sm text-[15px]">
                Five movements. Not a program to complete — a sequence that takes you
                from living inside the pattern to standing outside it, looking at it, in gold.
              </p>
              <GoldSeam variant="horizontal" className="mt-9 w-48 h-9 opacity-60" delay={0.2} />
              <Link
                to="/approach"
                data-testid="method-read-more-link"
                className="gold-underline-link inline-block mt-8 text-[11px] uppercase tracking-[0.28em] text-gold"
              >
                The method, expanded
              </Link>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.06}>
              <div
                className="flex items-baseline gap-6 md:gap-10 py-8 md:py-10 border-t border-[rgba(169,129,47,0.26)] group"
                data-testid={`method-step-${s.n}`}
              >
                <span className="text-[11px] tracking-[0.3em] text-gold/70 w-8 shrink-0">{s.n}</span>
                <h3 className="font-display text-3xl md:text-5xl text-ink font-medium w-44 md:w-64 shrink-0 group-hover:text-goldink transition-colors duration-500">
                  {s.name}
                </h3>
                <p className="text-inkdim text-sm md:text-[15px] leading-relaxed hidden sm:block">{s.line}</p>
              </div>
              <p className="sm:hidden text-inkdim text-sm leading-relaxed -mt-5 pb-6 pl-14">{s.line}</p>
            </Reveal>
          ))}
          <Reveal delay={0.2}>
            <div className="border-t border-[rgba(169,129,47,0.26)] pt-10">
              <p className="font-display italic text-goldink text-2xl md:text-3xl leading-snug" data-testid="method-closing-line">
                "You can't reframe what you refuse to see first."
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
